export const REPORTS_TRANSLATIONS = {
  Reports: "Raporty",

  lastReports: "Ostatnie {{count}} raporty",
  lastReports_zero: "Brak dostępnych raportów",
  lastReports_one: "Ostatni raport",

  report_type_farm_animals: "Raport Ogólny Zwierząt",
  report_type_individual_animal: "Raport Indywidualny Zwierzęcia",
  report_type_farm: "Raport Farmy",
  report_type_apiary: "Raport Pasieki",
  report_type_crops: "Raport Upraw",
  newReport: "Nowy Raport",
  download: "Pobierz",
  view: "Zobacz",
  generateReport: "Generuj Raport",
}
